import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseConfig } from '@fuse/types/fuse-config';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SubscriptionBannerModel } from './components/subscription-banner/subscription-banner.model';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { ContextMenuHolderComponent } from '../core/services/context-menu/context-menu-holder/context-menu-holder.component';
import { CustomerAreaMessageBannerComponent } from './components/customer-area-message-banner/customer-area-message-banner.component';
import { LaboratoryAreaMessageBannerComponent } from './components/laboratory-area-message-banner/laboratory-area-message-banner.component';
import { SubscriptionBannerComponent } from './components/subscription-banner/subscription-banner.component';
import { StorageBannerComponent } from './components/storage-banner/storage-banner.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ContentComponent } from './components/content/content.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { FuseSidebarComponent } from '../../@fuse/components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-vertical-layout-1',
  styleUrls: ['./layout.component.scss'],
  templateUrl: './layout.component.html',
  imports: [
    NgTemplateOutlet,
    ContextMenuHolderComponent,
    CustomerAreaMessageBannerComponent,
    LaboratoryAreaMessageBannerComponent,
    SubscriptionBannerComponent,
    StorageBannerComponent,
    CdkScrollable,
    ContentComponent,
    ToolbarComponent,
    NgClass,

    FooterComponent,
    FuseSidebarComponent,
    NavbarComponent,
    SidebarComponent,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  @ViewChild('_sidebarComponent') private _sidebarComponent: SidebarComponent;
  public fuseConfig: FuseConfig;
  public subscriptionBanner: SubscriptionBannerModel;

  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _fuseConfigService = inject(FuseConfigService);
  private _unsubscribeAll$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  public ngOnInit(): void {
    // Subscribe to config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll$)).subscribe((config) => {
      this.fuseConfig = config;
      this._changeDetectorRef.markForCheck();
    });
  }

  public sidebarOpenedChangedHandler(opened: boolean): void {
    if (opened) {
      this._sidebarComponent.afterOpenedHandler();
    } else {
      this._sidebarComponent.afterClosedHandler();
    }
  }
}
